import React from "react";
import { AiFillPlusCircle, AiOutlineDelete } from "react-icons/ai";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { NavLink } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  addToCart,
  emptyWhishList,
  removeWhishlistItem,
} from "../actions/action";

function Whishlist() {
  const wishlistProducts = useSelector((state) => state.AddToWhishList);

  const dispatch = useDispatch();

  return (
    <div className="font-primary">
      <div className="pl-5 pt-14 pb-10 w-[90%] mx-auto flex justify-start items-center">
        Home <MdOutlineKeyboardArrowRight size="20" /> Whishlist
        <MdOutlineKeyboardArrowRight size="20" />
      </div>
      {/* table of Whishlist */}
      <div className="w-[88%] mx-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-background text-gray-900">
              <th className="whishlist-table-heading">Product</th>
              <th className="whishlist-table-heading">Price</th>
              <th className="whishlist-table-heading">Category</th>
              <th className="whishlist-table-heading">Subtotal</th>
              <th className="whishlist-table-heading"></th>
              <th className="whishlist-table-heading"></th>
            </tr>
          </thead>
          <tbody>
            {wishlistProducts.map((product) => {
              return (
                <tr key={product.id}>
                  <td className="py-2 px-4 font-bold text-primary flex items-center">
                    <img width="30" src={product.image} alt="product" />
                    <span className="pl-2">{product.name}</span>
                  </td>
                  <td className="py-2 px-4">${product.price}</td>
                  <td className="py-2 px-4">
                    <span>{product.category}</span>
                  </td>
                  <td className="py-2 px-4">${product.price}</td>
                  <td className="text-center">
                    <button
                      onClick={() =>
                        dispatch(
                          addToCart({
                            id: product.id,
                            category: product.category,
                            name: product.name,
                            price: product.price,
                            image: product.image,
                            quantity: product.quantity,
                          })
                        )
                      }
                    >
                      <AiFillPlusCircle size="30" />
                    </button>
                  </td>
                  <td className="text-center">
                    <button
                      onClick={() => dispatch(removeWhishlistItem(product.id))}
                    >
                      <AiOutlineDelete size="25" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="flex justify-between pt-10 pb-6">
          <NavLink
            to="/shop/category"
            className="bg-secondary text-white px-6 py-4 rounded-2xl"
          >
            Continue Shopping
          </NavLink>
          <button
            onClick={() => dispatch(emptyWhishList())}
            className="bg-transparent border border-red-400 text-red-600 px-6 py-4 rounded-2xl"
          >
            Clear Whishlist
          </button>
        </div>
      </div>
    </div>
  );
}

export default Whishlist;
